// import React, { useState } from "react";
import { Button, Typography, Grid, Dialog, DialogContent, DialogContentText } from "@mui/material";
import PropTypes from "prop-types";
// import { PersonOutline } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { useColorTheme } from "../../../context/ColorThemeContext";

function DetaiUser({ open, onClose, selectedUser }) {
  const colors = useColorTheme();

  const handeClose = () => {
    onClose();
  };

  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: "40% !important", // Đặt độ rộng là 40%
          maxWidth: "none", // Bỏ giới hạn mặc định
        },
      }}
      open={open}
      onClose={onClose}
    >
      <DialogTitle
        sx={{
          backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
          color: colors.popupText || "white !important",
          padding: "13px 20px",
          fontWeight: "bold",
          fontSize: "18px",
          position: "relative",
          display: "flex",
          justifyContent: "center",
        }}
      >
        Thông tin người dùng
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white !important",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ paddingTop: "10px !important" }}>
        <DialogContentText id="alert-dialog-description">
          <Grid spacing={3} container mb={1} mt={0.5}>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography fontSize="14px" className={selectedUser?.fullName ? "has-value" : ""}>
                <span className="spanDetailUser">Tên đăng nhập:</span>
                <span style={{ color: "black" }}> {selectedUser?.username}</span>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography fontSize="14px" className={selectedUser?.fullName ? "has-value" : ""}>
                <span className="spanDetailUser">Họ tên:</span>
                <span style={{ color: "black" }}> {selectedUser?.fullName}</span>
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={1}>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography fontSize="14px" className={selectedUser?.cccd ? "has-value" : ""}>
                <span className="spanDetailUser">CCCD:</span>
                <span style={{ color: "black" }}> {selectedUser?.cccd || ""}</span>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography fontSize="14px" className={selectedUser?.birthday ? "has-value" : ""}>
                <span className="spanDetailUser">Ngày sinh: </span>
                <span style={{ color: "black" }}>
                  {selectedUser?.birthday
                    ? new Date(selectedUser.birthday).toLocaleDateString("vi-VN")
                    : ""}
                </span>
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={1}>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography fontSize="14px" className={selectedUser?.email ? "has-value" : ""}>
                <span className="spanDetailUser">Email:</span>
                <span style={{ color: "black" }}> {selectedUser?.email}</span>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography fontSize="14px" className={selectedUser?.phone ? "has-value" : ""}>
                <span className="spanDetailUser">Số điện thoại:</span>
                <span style={{ color: "black" }}> {selectedUser?.phone}</span>
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={1}>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography fontSize="14px" className={selectedUser?.roleName ? "has-value" : ""}>
                <span className="spanDetailUser">Vai trò:</span>
                <span style={{ color: "black" }}>
                  {" "}
                  {selectedUser?.roleName || "Chưa phân quyền"}
                </span>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography
                fontSize="14px"
                className={selectedUser?.departmentName ? "has-value" : ""}
              >
                <span className="spanDetailUser">Phòng ban:</span>
                <span style={{ color: "black" }}> {selectedUser?.departmentName || ""}</span>
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={1}>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography fontSize="14px" className={selectedUser?.areaName ? "has-value" : ""}>
                <span className="spanDetailUser">Địa bàn hành chính:</span>
                <span style={{ color: "black" }}> {selectedUser?.areaName || ""}</span>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography fontSize="14px" className={selectedUser?.status ? "has-value" : ""}>
                <span className="spanDetailUser">Trạng thái: </span>
                <span style={{ color: "black" }}>
                  {selectedUser?.status === 1 ? "Hoạt động" : "Khóa"}
                </span>
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={1}>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography
                fontSize="14px"
                className={selectedUser?.fullNameLeader1 ? "has-value" : ""}
              >
                <span className="spanDetailUser">Tên lãnh đạo trực tiếp 1:</span>
                <span style={{ color: "black" }}> {selectedUser?.fullNameLeader1 || ""}</span>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <Typography
                fontSize="14px"
                className={selectedUser?.fullNameLeader2 ? "has-value" : ""}
              >
                <span className="spanDetailUser">Tên lãnh đạo trực tiếp 2:</span>
                <span style={{ color: "black" }}> {selectedUser?.fullNameLeader2 || ""}</span>
              </Typography>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          paddingTop: "0px !important",
          mb: 1,
          justifyContent: "center", // Căn giữa theo chiều ngang
          display: "flex",
        }}
      >
        <Button
          sx={{
            "&.MuiButton-root.MuiButton-contained": {
              boxShadow: "none !important",
              fontWeight: "normal",
              height: "36px !important",
              maxHeight: "36px !important",
            },
            "&.MuiButton-root": {
              minHeight: "36px !important",
            },
            backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
            color: colors.popupText || "white",
            "&:hover": {
              backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
              boxShadow: "none !important",
            },
          }}
          variant="contained"
          onClick={handeClose}
          style={{
            fontWeight: "normal",
          }}
        >
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
}
DetaiUser.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedUser: PropTypes.objectOf(String).isRequired,
};

export default DetaiUser;
